/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */

import React, {useState, useEffect} from 'react';
import {CardModal} from '../cardModal/cardModal';

import {CardComponent} from './cardComponent/cardComponent';
import {LargeButton, Loader, Modal, NavbarButton} from '../../../../components';
import {Admin} from '../../../../utils/api';
import {CardsContainer, PaymentSection, TextAlert, WarningModalWrapper, TitleEmpty, EmptyWrapper} from './styles';
export default () => {
  const [addCardModal, useCardModal] = useState(false);

  const [userCards, useUserCards] = useState<Array<any>>([]);
  const [warningModal, useWarningModal] = useState(false);
  const [loading, useLoading] = useState(false);
  const [defaultCard, useDefaultCard] = useState<any>({});
  const ADMIN = new Admin();
  useEffect(() => {
    FetchPaymentMethods();
  }, []);
  async function FetchPaymentMethods() {
    useLoading(true);

    const response: any = await ADMIN.GetPaymentMethods();
    if (response?.status) {
      if (response?.data?.length > 0) {
        const defaultCards = response?.data?.filter(item => item?.default);
        if (defaultCards) useDefaultCard(defaultCards[0]);

        useUserCards([...response?.data]);

        useLoading(false);
      } else {
        useUserCards([...response?.data]);
        useWarningModal(false);
        useLoading(false);
      }
    } else {
      console.error(response);
      useLoading(false);
    }
  }

  function usemodal(val) {
    useCardModal(val);
  }
  function handleClickOutside(e) {
    if (e.target.id === 'modal') {
      usemodal(false);
      useWarningModal(false);
    }
  }

  return (
    <PaymentSection>
      {!loading ? (
        <>
          {!defaultCard && <TextAlert>Select a default credit card.</TextAlert>}
          {userCards.length ? (
            <CardsContainer>
              {userCards.map((card, index) => {
                return <CardComponent key={index} cardInfo={card} fetchCards={FetchPaymentMethods} />;
              })}
            </CardsContainer>
          ) : (
            <>
              {warningModal ? (
                <div onClick={handleClickOutside}>
                  <Modal title="Add Credit Card">
                    <WarningModalWrapper>
                      <span>Add your credit card to support sponsored memberships.</span>
                      <NavbarButton title="Close" onClick={() => useWarningModal(false)} />
                      <LargeButton
                        callback={() => {
                          useCardModal(true);
                          useWarningModal(false);
                        }}
                        lColor="#006BE1"
                        rColor="rgba(0,122,255,1)"
                        icon="plus"
                        title="ADD CARD"
                      />
                    </WarningModalWrapper>
                  </Modal>
                </div>
              ) : (
                <>
                  <EmptyWrapper>
                    <TitleEmpty>You don't have any credit card registered</TitleEmpty>
                    <TextAlert>Add your credit card to support sponsored memberships.</TextAlert>
                  </EmptyWrapper>
                </>
              )}
            </>
          )}
        </>
      ) : (
        <Loader />
      )}

      {addCardModal && (
        <div onClick={handleClickOutside}>
          <CardModal handleModalFunction={usemodal} refreshCards={FetchPaymentMethods} />
        </div>
      )}
      <LargeButton
        callback={() => useCardModal(true)}
        title="ADD A CREDIT CARD"
        lColor="#006BE1"
        rColor="rgba(0,122,255,1)"
        icon="plus"
        xMargin={'25px auto 25px 0px'}
      />
    </PaymentSection>
  );
};
